import { render, staticRenderFns } from "./InstrumentName.vue?vue&type=template&id=2b4ed907&scoped=true"
import script from "./InstrumentName.vue?vue&type=script&lang=ts"
export * from "./InstrumentName.vue?vue&type=script&lang=ts"
import style0 from "./InstrumentName.vue?vue&type=style&index=0&id=2b4ed907&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4ed907",
  null
  
)

export default component.exports